import { createFetch } from './createFetch';

/**
 * Default `fetch` function configured for a typical usage.
 */
export const fetch = createFetch();
